import * as _ from "lodash";
import * as angular from "angular";
import { CanvassService } from "../../services/canvass.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

export class CanvassActivity {
    private $scope: any;
    private dialog: DialogUtils;
    private toast: ToastUtils;
    private service: CanvassService;

    constructor(
        CanvassService: CanvassService,
        DialogUtils: DialogUtils,
        ToastUtils: ToastUtils,
        $rootScope: any
    ) {
        this.$scope = $rootScope;
        this.dialog = DialogUtils;
        this.toast = ToastUtils;
        this.service = CanvassService;
    }

    openCanvassDialog(canvass: any, ev: any): void {
        this.dialog
            .show({
                component: "vc-canvass-form",
                targetEvent: ev,
                scope: this.$scope,
                skipHide: true,
                locals: {
                    selectedHouseOccupant: null,
                    selectedHouse: null,
                    selectedCanvass: canvass,
                },
                size: "x-large",
                ariaLabel: "Interaction",
            })
            .then((data) => _.merge(canvass, data));
    }

    deleteCanvass(canvass: any, dataProvider: any, ev: any): void {
        this.dialog
            .delete({
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                locals: {
                    title: "Delete Interaction?",
                    bodyText: "This will permanently delete the interaction",
                },
            })
            .then(() => {
                this.service
                    .delete({ id: canvass.csid })
                    .then((response: object) => {
                        const json = response["data"];
                        if (json.success) {
                            this.toast.success("Interaction deleted");
                            dataProvider.removeActivity(canvass);
                        } else {
                            this.toast.error();
                        }
                    });
            });
    }
}

angular.module("canvass", []).service("CanvassActivity", CanvassActivity);
